import { UserRole } from "@faire/web-api--source/indigofair/data/UserRole";

import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";

export const isUserMakerEditor = () => {
  const userRoles = UserStore.get().user?.roles;

  if (!userRoles) {
    return false;
  }

  return userRoles.includes(UserRole.MAKER_EDITOR);
};
